import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import ImageTools from './pages/ImageTools';
import VideoTools from './pages/VideoTools';
import PDFTools from './pages/PDFTools';
import CompressPDF from './pages/CompressPDF';
import TextToPDF from './pages/TextToPDF';
import Workspace from './pages/Workspace';
import ImageCompressor from './pages/ImageCompressor';
import ImageCropper from './pages/ImageCropper';
import Base64Converter from './pages/Base64Converter';
import PDFMerge from './pages/PDFMerge';
import PDFSplit from './pages/PDFSplit';
import PDFToImages from './pages/PDFToImages';
import PDFWatermark from './pages/PDFWatermark';
import PDFOrganize from './pages/PDFOrganize';
import VideoToAudio from './pages/VideoToAudio';
import VideoToGIF from './pages/VideoToGIF';
import VideoAudioRemover from './pages/VideoAudioRemover';
import VideoCompressor from './pages/VideoCompressor';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <ScrollToTop />
          <div className="App">
            <Navbar />
            <main className="app-main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/image-tools" element={<ImageTools />} />
                <Route path="/video-tools" element={<VideoTools />} />
                <Route path="/pdf-tools" element={<PDFTools />} />
                <Route path="/compress-pdf" element={<CompressPDF />} />
                <Route path="/text-to-pdf" element={<TextToPDF />} />
                <Route path="/image-converter" element={<Workspace />} />
                <Route path="/image-compressor" element={<ImageCompressor />} />
                <Route path="/image-cropper" element={<ImageCropper />} />
                <Route path="/base64-converter" element={<Base64Converter />} />
                <Route path="/pdf-merge" element={<PDFMerge />} />
                <Route path="/pdf-split" element={<PDFSplit />} />
                <Route path="/pdf-to-images" element={<PDFToImages />} />
                <Route path="/pdf-watermark" element={<PDFWatermark />} />
                <Route path="/pdf-organize" element={<PDFOrganize />} />
                <Route path="/video-to-audio" element={<VideoToAudio />} />
                <Route path="/video-to-gif" element={<VideoToGIF />} />
                <Route path="/video-audio-remover" element={<VideoAudioRemover />} />
                <Route path="/video-compressor" element={<VideoCompressor />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
